import { Component, ElementRef, HostBinding, HostListener, Input, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';

@Component({
  selector: 'as-card',
  templateUrl: './as-card.component.html',
  styleUrls: ['./as-card.component.scss']
})
export class AsCardComponent implements OnInit {

  @Input() explanation?: string | null;
  @Input() label?: string;
  @Input() disabled: boolean = false;
  @Input() showOutline: boolean = true;
  @Input() centerLabel: boolean = false;

  @ViewChild('asCardWrapper') asCardWrapper?: ElementRef;
  @ViewChild('asCardLabelText') asCardLabelText?: ElementRef;
  @ViewChildren('asCardOutlineGap') asCardOutlineGap?: QueryList<ElementRef>;

  isActive: boolean = false;

  ngTnsClass?: string;

  constructor(private renderer: Renderer2) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.updateGapWidth();
  }

  @HostBinding('window.resize')
  updateGapWidth() {
    if (this.asCardLabelText && this.asCardOutlineGap && !this.centerLabel) {
      let width = this.asCardLabelText.nativeElement.offsetWidth * 0.75 + 12;
      this.asCardOutlineGap.forEach((item) => {
        this.renderer.setStyle(item.nativeElement, 'width', width + 'px');
      });
    }
  }

  // @HostListener('document:mousedown', ['$event'])
  // onOutsideClick(event: any): void {
  //   // not the perfect solution
  //   if (this.asCardWrapper) {
  //     if (this.asCardWrapper.nativeElement.contains(event.target)) {
  //       if (!this.disabled) this.isActive = true;
  //       this.ngTnsClass = (event.target.classList as DOMTokenList).value.split(' ').find((c: string) => c.startsWith('ng-tns-c'));
  //     } else if (!this.ngTnsClass || (event.target.closest('.' + this.ngTnsClass) == null && !(event.target.classList as DOMTokenList).value.includes(this.ngTnsClass))) {
  //       this.isActive = false;
  //     }
  //   }
  // }

}
